import React from 'react';
import { AuthLayout } from '../layouts/AuthLayout';
import { useAuth } from '../contexts/AuthContext';

export function AuthLayoutWrapper({ children, currentUser }) {
    const { loginWithMsal, logout } = useAuth();

    const handleMsalLogin = () => {
        loginWithMsal();
    };

    const handleLogout = () => {
        logout();
    };

    return (
        <AuthLayout
            currentUser={currentUser}
            handleMsalLogin={handleMsalLogin}
            handleLogout={handleLogout}
        >
            {children}
        </AuthLayout>
    );
}